<div class="common-model-nav">
  <div class="height-separater">
    <div class="stk-back-btn"></div>
    <div class="stk-nav">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            <a [routerLink]="['/maintenance/group']">Group Maintenance </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">View Group</li>
        </ol>
      </nav>
    </div>
  </div>
</div>
<div class="lob-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header">
        <span class="stk-container-header">
          <span class="stk-title">
            <span class="stk-header-title" style="font-size: 20px;">View Details</span>
          </span>
        </span>
        <span class="stk-c-header stk-container-header" style="float: right; padding-right: 2.32%;cursor: pointer;">
          <i (click)="showpopup()" class="m-1 uitk-icon uitk-icon-info_hollow health"></i>
        </span>
        @if (createdAt) {
        <span class="stk-c-header stk-container-header" style="float: right; padding-right: 30px;">
          Created on: <strong>{{ createdAt | date: 'mediumDate' }}</strong>
          @if (updatedAt) {
          <span>
            Updated On: <strong>{{ updatedAt | date: 'mediumDate' }}</strong></span
          >
          }
        </span>
        }
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
            <div class="row">
              <div class="col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3">
                <span class="stk-c-header stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 12px;">App Group Name</span>
                  </span>
                  <div>
                    <span style="padding-left: 5.12%; padding-top: 1.70%;">
                      {{ groupName }}
                    </span>
                  </div>
                </span>
              </div>
              <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                <span class="stk-c-header stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 12px;">App Group Type</span>
                  </span>
                  <div>
                    <span style="padding-left: 8.10%; padding-top: 2.70%;">
                      {{ groupType }}
                    </span>
                  </div>
                </span>
              </div>
              <div class="col-md-2 col-sm-12 col-lg-2 col-xl-2 col-xs-2">
                <span class="stk-c-header stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 12px;">Visibility</span>
                  </span>
                  <div>
                    <span style="padding-left: 15px; padding-top: 5px;">
                      {{ visibility }}
                    </span>
                  </div>
                </span>
              </div>
              <!-- </div> -->
              <div class="col-md-5 col-sm-12 col-lg-5 col-xl-5 col-xs-5">
                <span class="stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 12px;">Description</span>
                  </span>
                  <div style="padding-left: 15px; padding-top: 5px;font-family: Arial Regular !important;">
                    <span>
                      {{ description }}
                    </span>
                  </div>
                </span>
              </div>
            </div>
            <div class="row" style="padding-bottom: 20px;padding-top: 5px;">
              <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
                <span class="stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 12px;">Owner</span>
                  </span>
                </span>

                <div style="padding-left: 15px;">
                  {{ sharedGroupsWith }}
                </div>
              </div>
            </div>
            <hr />
            <div class="row" style="padding-left: 20px; width: 100%;min-width: 100%;max-width: 100%;">
              <div class="app-stk-header" style="min-width: 10%;max-width: 10%;">
                <span class="stk-c-header stk-container-header">
                  <span class="stk-title">
                    <span class="stk-header-title" style="font-size: 18px;">Applications</span>
                  </span>
                </span>
              </div>
              <div class="search-padding" style="min-width: 30%;max-width: 30%;">
                <ng-container>
                  <div class="table-search">
                    <mat-form-field class="data-filter" appearance="outline">
                      <input
                        [(ngModel)]="searchField"
                        matInput
                        type="text"
                        class="capability-search"
                        placeholder="Search Application"
                        (keyup)="searchDataSet($event.target.value)"
                      />
                      <img
                        src="../../../../assets/images/searchicon.png"
                        style="position: absolute;
                                        right: 0px;
                                        top: 7px;"
                      />
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="padding-bottom: 1.58%;padding-top:1.58%;padding-left: 1.58%;">
          <div class="maintenance-table-container" style="width: 100%;">
            <div class="table-container">
              <table
                matSort
                mat-table
                [dataSource]="dataSource"
                (matSortChange)="sortData($event)"
                class="mat-elevation-z8"
              >
                <ng-container matColumnDef="ApplicationID">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef style="font-size: 12px;">
                    Application Id @if (!appIdFilterApplied) {
                    <span
                      (click)="filterDropdown('ApplicationID'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                    </span>
                    } @if (appIdFilterApplied) {
                    <span
                      (click)="filterDropdown('ApplicationID'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                    </span>
                    }
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.ApplicationID }}</td>
                </ng-container>

                <ng-container matColumnDef="ApplicationName">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef style="font-size: 12px;">
                    Application Name @if (!appNameFilterApplied) {
                    <span
                      (click)="filterDropdown('ApplicationName'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                    </span>
                    } @if (appNameFilterApplied) {
                    <span
                      (click)="filterDropdown('ApplicationName'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                    </span>
                    }
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.ApplicationName }}</td>
                </ng-container>
                <ng-container matColumnDef="Category">
                  <th
                    mat-header-cell
                    mat-sort-header
                    *matHeaderCellDef
                    style="font-size: 12px; width: 200px !important;"
                  >
                    Category @if (!categoryFilterApplied) {
                    <span
                      (click)="filterDropdown('Category'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                    </span>
                    } @if (categoryFilterApplied) {
                    <span
                      (click)="filterDropdown('Category'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                    </span>
                    }
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.Category }}</td>
                </ng-container>
                <ng-container matColumnDef="App_Lifecycle_Status">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef style="font-size: 12px;">
                    App Lifecycle Status @if (!appLifecycleFilterApplied) {
                    <span
                      (click)="filterDropdown('App_Lifecycle_Status'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png" />
                    </span>
                    } @if (appLifecycleFilterApplied) {
                    <span
                      (click)="filterDropdown('App_Lifecycle_Status'); $event.stopPropagation()"
                      [matMenuTriggerFor]="contextMenu"
                      #trigger="matMenuTrigger"
                    >
                      <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png" />
                    </span>
                    } &nbsp; &nbsp;
                  </th>

                  <td mat-cell *matCellDef="let element">{{ element.App_Lifecycle_Status }}</td>
                </ng-container>

                <ng-container matColumnDef="reset_filter">
                  <th mat-header-cell *matHeaderCellDef style="font-size: 12px;">
                    &nbsp; &nbsp; @if ((appIdFilterApplied || appNameFilterApplied || categoryFilterApplied ||
                    appLifecycleFilterApplied)) {
                    <span (click)="clearallFilter()">
                      <i
                        title="Reset Filters"
                        class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"
                      ></i>
                    </span>
                    }
                  </th>

                  <td mat-cell *matCellDef="let element"></td>
                </ng-container>

                <mat-menu #contextMenu="matMenu">
                  <div
                    class="menu-filter-popup"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  >
                    <input
                      matInput
                      type="text"
                      class="searchoption"
                      (keydown)="$event.stopPropagation()"
                      class="form-control filter-search-bar"
                      [(ngModel)]="searchTxt"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Search"
                    />
                    <mat-selection-list
                      class="filter-list-container"
                      (selectionChange)="selectionChange($event)"
                      [disableRipple]="true"
                      [(ngModel)]="filValue"
                      [ngModelOptions]="{ standalone: true }"
                    >
                      @for (row of filterLists | search : searchTxt; track row) {
                      <mat-list-option checkboxPosition="before" [value]="row"> {{ row }}</mat-list-option>
                      }
                    </mat-selection-list>
                    <span
                      style="cursor:pointer; float: right;padding-right: 70px;"
                      class="small localApplyButton"
                      (click)="applyLocalFilter()"
                      >Apply</span
                    >
                    <span
                      style="cursor:pointer; float: right;padding-right: 22px;"
                      class="small localApplyButton"
                      (click)="clearLocalFilter()"
                      >Clear</span
                    >
                  </div>
                </mat-menu>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>

              <ng-container>
                <mat-paginator
                  #paginator
                  [pageSizeOptions]="[5, 10, 20]"
                  showFirstLastButtons
                  aria-label="Select page of listed group"
                >
                </mat-paginator>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hover_bkgr_fricc" (click)="hidepopup()">
      <span class="helper"></span>
      <div
        style="background: #fff;
        text-align: left;
        overflow-y: scroll;
        height: 500px;"
      >
        <div class="popupCloseButton" (click)="hidepopup()">&times;</div>
        <p><strong>a. Create and Edit page for Admins: </strong></p>

        <p>· App Group Type can either be Platform or Custom, Visibility can either be Public or Private</p>

        <p>· If App Group Type is Platform, Visibility can be Public or Private</p>

        <p>· If App Group Type is Platform and Visibility is Public, it will not have a share Option</p>

        <p>
          · If App Group Type is Platform and Visibility is Private, it will have a share Option and limited to 9 users
          other than author.
        </p>

        <p>· If the Admin is not The Group Owner, Share and transfer should not be available</p>

        <p>
          · If App Group Type is Custom, Visibility can only be Private and can be shared with 9 users other than
          author.
        </p>

        <p><strong>b. Create and Edit page for Non-Admin Users: </strong></p>

        <p>· App Group Type can only be Custom and Visibility Private.</p>

        <p>· Owner of the App Group will have Edit, Share, Transfer, View icons</p>

        <p>· User with who the App Group is shared with can only see View icon</p>

        <p>· Deleting a Group will only be allowed to the App Group Owner</p>

        <p><strong>c. Select By option: </strong></p>

        <p>
          · When "selected by" value is "LOB" and if value in LOB and Sub-LOB is blank, then show all the applications
          under "Application" drop down.
        </p>

        <p>
          · When "selected by" value is "LOB" and if value in LOB and/or Sub-LOB is selected, then show only the
          filtered applications based on selected LOB/Sub-LOB.
        </p>

        <p>
          · When "selected by" value is "Tech Owner" and if value in Tech Owner is blank, then show all the applications
          under "Application" drop down.
        </p>

        <p>
          · When "selected by" value is "Tech Owner" and if value in Tech Owner is selected, then show only the filtered
          applications based on selected Tech Owner.
        </p>

        <p>
          · When "selected by" value is "SLO" and if value in SLO is blank, then show all the applications under
          "Application" drop down.
        </p>

        <p>
          · When "selected by" value is " SLO " and if value in SLO is selected, then show only the filtered
          applications based on selected SLO.
        </p>

        <p><strong>d. Export to Excel </strong></p>

        <p>· Should contain all the details that shown in View Details screen</p>

        <p><strong>e. All existing Groups are defaulted to App Group Type “Custom” and Visibility “Private”</strong></p>

        <p><strong> Edit application group</strong></p>

        <p><strong>f. Manage sharing tab will be visible on if the Visibility is “Private” </strong></p>
      </div>
    </div>
  </div>
</div>
